import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { ProblemForUserModel } from './model';
import { problemForUserAdapter, ProblemForUserState } from './state';

export const stateName: string = 'problemForUser';

export const getError = (state: ProblemForUserState): any => state.error;

export const getIsLoading = (state: ProblemForUserState): boolean => state.isLoading;

export const selectProblemForUserState: MemoizedSelector<object, ProblemForUserState> =
  createFeatureSelector<ProblemForUserState>(stateName);

export const selectAll: (state: object) => ProblemForUserModel[] = problemForUserAdapter.getSelectors(selectProblemForUserState).selectAll;

export const selectError: MemoizedSelector<object, any> = createSelector(selectProblemForUserState, getError);

export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectProblemForUserState, getIsLoading);
